import type { PropsWithChildren, ReactNode } from "react";
import type { TypographyProps } from "@mui/material";
import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import BackButton from "components/atoms/buttons/BackButton";

interface PageTitleProps extends PropsWithChildren {
  noBackButton?: boolean;
  title: string | ReactNode;
  typographyProps?: TypographyProps;
}

function PageTitle({
  noBackButton = false,
  children,
  title,
  typographyProps,
}: Readonly<PageTitleProps>): ReactNode {
  return (
    <Grid container size={12} sx={{ bgcolor: grey[100], p: 2, mb: 2, alignItems: "center" }}>
      {!noBackButton && <BackButton />}
      <Typography variant="h2" {...typographyProps}>
        {title}
      </Typography>
      {children}
    </Grid>
  );
}

export default PageTitle;
